import { GesturePlugin } from '@vueuse/gesture'
import Vue from 'vue'

Vue.use(GesturePlugin)
